document.addEventListener('DOMContentLoaded', function() {
  // Event listener for product spec button
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('AddtoBundleCart') || e.target.closest('.AddtoBundleCart')) {
      const button = e.target.classList.contains('AddtoBundleCart') ? e.target : e.target.closest('.AddtoBundleCart');
      const bundleContactUs = '<a href="/pages/contact-us-about-a-product?00No000000AFXbt=About: '+button.getAttribute('data-ptitle')+'&handle='+button.getAttribute('data-phandle')+'">Contact Us</a>';

      const buttonform = button.closest('form');console.log('buttonform', buttonform);
      const formData = new FormData(buttonform);
      let serializedData = [];
      formData.forEach((value, key) => {
          serializedData.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });

      const serializedString = serializedData.join('&');

     
      const bundleStoreId = 1;
      const bundleProductId = button.getAttribute('data-productId');
      var dropdown = document.getElementById("product-qty-"+bundleProductId);
      var selectedQty = dropdown.value;
      var quantityInputs = document.querySelectorAll('.formVariantId');
      var bundleVariantId = 0;
      quantityInputs.forEach(function(input) {
        bundleVariantId = input.value;
      });

      console.log(button);
      button.value = 'Please wait...';
      button.disabled = true; 



      // Define the data you want to send in the request
      var data = {
        variant_id: bundleVariantId,
        product_id: bundleProductId,
        quantity: selectedQty,
        formData: serializedString
      };
      
      // Create the request options for the fetch API
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data) // Convert the data object to a JSON string
      };
      
      // Perform the fetch request
      fetch('/apps/dp-hni/configurator-products/get-bundle-items-new/1', requestOptions)
        .then(response => response.json()) // Parse the JSON response
        .then(obj => {
          if (obj.response === 'success') {
            // Call the function to load items if the response is 'success'
            load_all_items(obj.carfInfo);
          } else if (obj.response === 'fail') {
            // Enable the button (using its ID)
            button.disabled = false; 
            // Reset the button text and show an error message
            button.value = config.adding_to_cart;//"Add to Cart";
            
            var errorMessage = document.createElement('span');
            errorMessage.className = 'bundleError';
            errorMessage.textContent = 'Server Error: ' + bundleContactUs + ' for more details.';
            // Append the span after the button using insertAdjacentElement
            button.insertAdjacentElement('afterend', errorMessage);
          } else {
            // Enable the button (using its ID)
            button.disabled = false; 
            // Handle the case where the response is neither 'success' nor 'fail'
            button.value = "Add to Cart";
            var errorMessage = document.createElement('span');
            errorMessage.className = 'bundleError';
            errorMessage.textContent = 'Server Error: ' + bundleContactUs + ' for more details.';
            button.insertAdjacentElement('afterend', errorMessage);
          }
        })
        .catch(error => {
          console.error('Error:', error);
          
          // Handle any network or other errors
        });
    }
  });
});

const getChank = (arr, chunkSize = 100)=> {
    let return_arr = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        return_arr.push(arr.slice(i, i + chunkSize));
    }
    return return_arr;
};

const load_all_items = async (cartItems)=> {
    let items = [];
    for(let ind in cartItems) {
      items.push(cartItems[ind]);
    }
    try{
      await addProductLoop(getChank(items, 50));
      document.location.href = '/cart/';
    }
    catch(error) {
      console.log(error);
    }
    
};

const addProductLoop = (arr)=> {
    return new Promise(async (resolve, reject)=> {
        let error;
        for(let items of arr) {
            try {              
                await addProductsToCart(items);
            }
            catch (err) {
                error = err;
                break;
            }
        }

        if(error) {
            reject(error);
        }
        else {
            resolve();
        }
    });
};

const addProductsToCart = (items)=> {
    return new Promise((resolve, reject)=> {
        let final_items = [];
        
        for(let item of items) {
            final_items.push({
                id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties
            });
        }

      console.log('final_items', final_items);
      // Prepare the data to be sent
      var data = {
        items: final_items
      };

      // Prepare the request options for fetch
      var requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data) // Convert the data object to a JSON string
      };

      // Perform the fetch request
      fetch('/cart/add.js', requestOptions)
        .then(response => response.json()) // Parse the JSON response
        .then(data => {
          // Success - resolve with the data
          resolve(data);
        })
        .catch(error => {
          // Error handling
          var msg = '';
          if (error instanceof TypeError) {
            msg = 'Network error or invalid URL';
          } else {
            msg = 'Uncaught Error: ' + error.message;
          }
          reject(msg);
        });
           
    });
};